// extracted by mini-css-extract-plugin
export default {"root":"IconChildFamily_root__8lXD5"};